"use client"

import { useContext, useEffect } from "react"

import type { GID } from "@unlikelystudio/commerce-connector"

import useLocale from "~/hooks/useLocale"
import { RecentlyViewedContext } from "~/providers/RecentlyViewedProvider"
import { addProductViewed } from "~/providers/RecentlyViewedProvider/utils/add-product"

export function ProductViewed({ id }: { id: GID }) {
  const context = useContext(RecentlyViewedContext)
  const locale = useLocale()

  useEffect(() => {
    if (id && locale) {
      addProductViewed(id, locale, context)
    }
  }, [])

  return null
}
